/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".pudo-locations-block[_ngcontent-%COMP%]{padding-left:25px;padding-top:10px}.p_rel[_ngcontent-%COMP%]{position:relative}"];
export { styles as styles };



// WEBPACK FOOTER //
// ./src/app/customerservice/templates/template1/themes/default/less/orders.component.less.shim.ngstyle.js.pre-build-optimizer.js